import { getRem } from "@datassential/platform-ui-lib";
import { components } from "@api/api";

export const FEATURE_AI_SEARCH = "CNPF AI Search";

export const CHART_COLORS = [
    '#66DEB2',
    '#7B16F5',
    '#F19B38',
    '#50B1F9',
    '#D82E85',
];

export const ALL_FOOD_BEVERAGE_CATEGORY = "All Food & Bev"

export enum TrendTab {
    HistoricTrend = 'historic-trend',
    TrendSummary = 'trend-summary',
}

export const TREND_CHART_QUARTERS = [
    { id: 'q1', title: 'Q1' },
    { id: 'q2', title: 'Q2' },
    { id: 'q3', title: 'Q3' },
    { id: 'q4', title: 'Q4' },
];

export enum HomeViewAs {
	Tile = 'Tile',
	Table = 'Table',
	Brands = 'Brands',
	People = 'People',
	Gain = 'Gain',
	Trend = 'Trend',
}

type HomeViewAsApi = components['schemas']['FlavorTracker.Entities.DTO.ViewModels.HomePageSettingsViewModel']['homePageViewType'];

export function mapHomeViewAsFromApi (apiValue: HomeViewAsApi): HomeViewAs {
    switch (apiValue) {
        case 1: return HomeViewAs.Tile;
        case 2: return HomeViewAs.Table;
        case 3: return HomeViewAs.Brands;
        case 4: return HomeViewAs.People;
        case 5: return HomeViewAs.Trend;
        case 6: return HomeViewAs.Gain;
        default: return HomeViewAs.Tile;
    }
}

export enum HomeShow {
    Raw = 'Raw',
    Norm = 'Norm',
    Index = 'Index',
}

type HomeShowApi = components['schemas']['FlavorTracker.Entities.DTO.ViewModels.HomePageSettingsViewModel']['homePageShowType'];

export function mapHomeShowFromApi (apiValue: HomeShowApi): HomeShow {
    switch (apiValue) {
        case 1: return HomeShow.Raw;
        case 2: return HomeShow.Norm;
        case 3: return HomeShow.Index;
        default: return HomeShow.Raw;
    }
}

export const COMMON_NUM_COL_WIDTH_PX = 90;
export const COMMON_NUM_COL_WIDTH = getRem(COMMON_NUM_COL_WIDTH_PX);
export const API_URL = process.env.REACT_APP_API;
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

export const HOME_SEARCH_QUERY_PARAM = 'search';
export const HOME_VIEW_AS_QUERY_PARAM = 'view';
export const HOME_SHOW_QUERY_PARAM = 'show';

